import { useSelector } from "react-redux";
import { useTotalFactura } from "../../../hook/useTotalFactura";
import { tienePlanAplicado } from "../../../utils/facturaCrear";
import "../../../styles/FacturaCrear.css";

/* ============================================================================
   CREAR FACTURA · antes de emitir

   Lo que hoy no existe: el usuario descubre que le falta algo cuando ya abrió
   el modal de emisión y el botón "Generar" está apagado sin decir por qué.

   ESTA LISTA NO VALIDA NADA NUEVO. Refleja las comprobaciones que YA existen,
   ni una más:

     · procedimientos agregados   -> de `total <= 0 && !tienePlan` (TotalesFactura)
     · vendedor                   -> de ConfirmBilling, que lo exige al emitir;
                                     aquí se anuncia, no se adelanta

   LA FORMA DE PAGO NO ESTÁ EN LA LISTA, a propósito: hoy se puede emitir sin
   registrar ninguna. Ponerla como requisito sería añadir una validación que el
   sistema no tiene, y este rediseño no cambia ninguna.
   ========================================================================== */

function Marca({ estado }) {
    if (estado === "ok") {
        return (
            <svg className="fcrear__chk fcrear__chk--ok" width="15" height="15" viewBox="0 0 24 24"
                 fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
                <path d="M4 12.5l5 5L20 7" />
            </svg>
        );
    }
    return (
        <svg className="fcrear__chk fcrear__chk--pend" width="15" height="15" viewBox="0 0 24 24"
             fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
            <circle cx="12" cy="12" r="8" />
        </svg>
    );
}

export default function AntesDeEmitir({ hayPaciente }) {
    const { total } = useTotalFactura();
    const procedimientos = useSelector((state) => state.facturaredux.procedimientos) || [];
    const formasPago = useSelector((state) => state.formapagoredux.pagos) || [];
    const tienePlan = tienePlanAplicado(procedimientos);

    const puntos = [
        {
            clave: "paciente",
            texto: "Paciente seleccionado",
            ok: Boolean(hayPaciente),
        },
        {
            clave: "procedimientos",
            texto: "Procedimientos agregados",
            ok: procedimientos.length > 0,
        },
        {
            clave: "total",
            texto: tienePlan ? "Total cubierto por el plan" : "Total mayor que cero",
            ok: !(Number(total) <= 0 && !tienePlan),
        },
        // Informativo: no bloquea hoy y no se convierte en requisito aquí.
        {
            clave: "pago",
            texto:
                formasPago.length > 0
                    ? `${formasPago.length} forma${formasPago.length === 1 ? "" : "s"} de pago registrada${formasPago.length === 1 ? "" : "s"}`
                    : "Sin forma de pago registrada (opcional)",
            ok: formasPago.length > 0,
            informativo: true,
        },
        {
            clave: "vendedor",
            texto: "El vendedor se elige al emitir",
            ok: false,
            informativo: true,
        },
    ];

    return (
        <div className="fcrear__card fcrear__card--pie">
            <div className="fcrear__ch">
                <span className="fcrear__ct">Antes de emitir</span>
            </div>
            <ul className="fcrear__lista">
                {puntos.map((p) => (
                    <li
                        key={p.clave}
                        className={`fcrear__lista-item${p.informativo ? " fcrear__lista-item--info" : ""}`}
                    >
                        <Marca estado={p.ok ? "ok" : "pendiente"} />
                        <span>{p.texto}</span>
                    </li>
                ))}
            </ul>
        </div>
    );
}
